import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {I18NEXT_SERVICE, ITranslationService} from 'angular-i18next';
import {AuthService} from 'app/core/services/auth.service';
import {DomService} from 'app/core/services/dom.service';
import {IntercomService} from 'app/core/services/intercom.service';
import {MixpanelService} from 'app/core/services/mixpanel.service';
import {PlaceholdersService} from 'app/core/services/placeholders.service';
import {RouterHelperService} from 'app/core/services/router-helper.service';
import {UserpilotService} from 'app/core/services/userpilot.service';
import {AppUrls} from 'app/core/url/app-urls.service';
import {LayoutService} from 'app/core/services/layout.service';
import {HubspotService} from 'app/core/services/hubspot.service';
import {GoogleAnalyticsService} from 'app/core/services/google-analytics.service';
import {getBuildInfo} from '../../../environments/buildInfo.helper';
import {AcceptTermsService} from 'app/core/services/accept-terms.service';
import {UaSettingsService} from 'app/features/analytics/service/ua-settings.service';

@Component({
    selector: 'app-root',
    templateUrl: './app-root.component.html',
    styleUrls: ['./app-root.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppRootComponent implements OnInit {
    buildInfo = getBuildInfo();
    urls = AppUrls;

    constructor(
        public auth: AuthService,
        public intercom: IntercomService,
        public routerHelper: RouterHelperService,
        public dom: DomService,
        @Inject(I18NEXT_SERVICE) public i18Next: ITranslationService,
        private placeholdersService: PlaceholdersService,
        private acceptTermsService: AcceptTermsService,
        private userpilot: UserpilotService,
        private mixpanel: MixpanelService,
        private layoutService: LayoutService,
        private hubspotService: HubspotService,
        public uaSettings: UaSettingsService,
        public googleAnalytics: GoogleAnalyticsService
    ) {}

    ngOnInit() {
        this.routerHelper.initialNavigation(this.auth.initError);
        this.initExtServices();
    }

    initExtServices() {
        this.dom.init();
        this.placeholdersService.init();
        this.googleAnalytics.init();
        this.userpilot.init();
        this.mixpanel.init();
        this.intercom.init();
        this.uaSettings.init();
        this.hubspotService.addHubspot();
        this.acceptTermsService.checkTerms();
    }

    termsLink() {
        return 'https://www.appodeal.com/home/terms-of-service/';
    }
}
